type SectionSkeletonProps = {
  tone?: "light" | "dark";
};

const SectionSkeleton = ({ tone = "light" }: SectionSkeletonProps) => {
  const base =
    tone === "dark"
      ? "bg-white/5 text-white"
      : "bg-muted/50 text-muted-foreground";
  const accent = tone === "dark" ? "bg-white/20" : "bg-muted";
  const muted = tone === "dark" ? "bg-white/10" : "bg-muted/70";

  return (
    <section className="py-12 lg:py-20">
      <div className="container mx-auto px-4">
        <div className={`space-y-4 rounded-3xl p-6 backdrop-blur-sm animate-pulse ${base}`}>
          <div className={`h-6 w-32 rounded-full ${accent}`} />
          <div className="space-y-2">
            <div className={`h-4 w-full rounded-full ${muted}`} />
            <div className={`h-4 w-11/12 rounded-full ${muted}`} />
            <div className={`h-4 w-9/12 rounded-full ${muted}`} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionSkeleton;
